import { Box, Link } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { AppConfigFields, ContactInfoFields } from "../types/appConfigEntities";

interface WhatsAppButtonProps {
  phoneNumber: string;
}

export default function WhatsAppButton({ phoneNumber }: WhatsAppButtonProps) {

    const contactInfo = window.APP_CONFIG[AppConfigFields.ContactData]
    const whatsappMessage = contactInfo?.[ContactInfoFields.WhatsappMessage] || "Hola como estas? Quiero solicitar información."

  return (
    <Link 
      href={`https://wa.me/${contactInfo?.[ContactInfoFields.Whatsapp]?.replace(/\D/g, '')}?text=${encodeURIComponent(whatsappMessage)}`} 
      target="_blank" 
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
    >
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          backgroundColor: '#4dc247',
          color: 'white',
          borderRadius: '50%',
          width: 45,
          height: 45,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: 3,
          transition: 'background-color 0.3s ease-in-out',
          '&:hover': {
            backgroundColor: 'black'
          },
          zIndex: 1500,
        }}
      >
        <WhatsApp sx={{ fontSize: 24 }} />
      </Box>
    </Link>
  );
}














